import axios from 'axios';

export const versionsService = {
    getPublishedVersions: () => axios.get('/versions/published', { auth: true }),
};
